import { createRouter, RouterProvider } from '@tanstack/react-router';

import { routeTree } from 'routes';

import { LoadingPage } from 'pages/loading-page';

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultPendingComponent: LoadingPage,
});

export const App = () => <RouterProvider router={router} />;
